export const obj = [
    {
        id: 1,
        title: "Notification",
        state: "private",
        date: "Monday",
        time: "1:54 AM",
        caption: "Notify Me Please!!! aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
        img: "././asdasd"
    },
    {
        id: 2,
        title: "Notification",
        state: "private",
        date: "Monday",
        time: "1:54 AM",
        caption: "Notify Me Please!!!",
        img: "././asdasd"
    },
    {
        id: 3,
        title: "Notification",
        state: "private",
        date: "Monday",
        time: "1:54 AM",
        caption: "Notify Me Please!!!",
        img: "././asdasd"
    },

]